import React from 'react';
import { Table, Column, Cell } from 'fixed-data-table';

class XpressTemplateKioskTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hoverRow: -1,
      highlightRow: -1,
    };

    this.handleRowHover = this.handleRowHover.bind(this);
    this.handleRowUnHover = this.handleRowUnHover.bind(this);
    this.shouldHighlight = this.shouldHighlight.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    //Reset the clicked row highlighting when the user searches
    if (this.props.rows != nextProps.rows) {
      this.setState({ highlightRow: -1 });
    }
  }

  handleRowHover(event, index) {
    this.setState({
      hoverRow: index,
    });
  }

  handleRowUnHover(event, index) {
    this.setState({
      hoverRow: -1,
    });
  }

  shouldHighlight(curRow) {
    return curRow == this.state.hoverRow || curRow == this.state.highlightRow;
  }

  onClick(event, index) {
    if (this.props.retainClick == true) {
      this.setState({
        highlightRow: index,
      });
    }

    this.props.onRowClick(event, index);
  }

  render() {
    const highlightColor = '#0489B1';

    return (
      <Table
        onRowClick={this.onClick}
        onRowMouseEnter={this.handleRowHover}
        onRowMouseLeave={this.handleRowUnHover}
        rowsCount={this.props.rowsCount}
        rowHeight={this.props.rowHeight}
        headerHeight={this.props.headerHeight}
        width={this.props.width}
        height={this.props.height}
      >
        <Column
          columnKey='kiosk'
          header={<Cell>Kiosk</Cell>}
          cell={(props) => (
            <Cell
              {...props}
              style={{
                cursor: 'pointer',
                color: 'blue',
                background: this.shouldHighlight(props.rowIndex) ? highlightColor : '#FFFFFF',
              }}
            >
              {this.props.rows[props.rowIndex].kiosk}
            </Cell>
          )}
          width={200}
        />
        <Column
          columnKey='location'
          header={<Cell>Location</Cell>}
          cell={(props) => (
            <Cell
              {...props}
              style={{
                cursor: 'pointer',
                color: 'blue',
                background: this.shouldHighlight(props.rowIndex) ? highlightColor : '#FFFFFF',
              }}
            >
              {this.props.rows[props.rowIndex].location}
            </Cell>
          )}
          width={500}
        />
        <Column
          columnKey='org'
          header={<Cell>Org</Cell>}
          cell={(props) => (
            <Cell
              {...props}
              style={{
                cursor: 'pointer',
                color: 'blue',
                background: this.shouldHighlight(props.rowIndex) ? highlightColor : '#FFFFFF',
              }}
            >
              {this.props.rows[props.rowIndex].org}
            </Cell>
          )}
          width={300}
        />
      </Table>
    );
  }
}

export default XpressTemplateKioskTable;



// WEBPACK FOOTER //
// ./src/components/XpressTemplateKioskTable.js